/**
 * Helper functions for filtering API data by VPC
 */

// Interface for API response items
interface ApiItem {
  elementId: string;
  vpcId: string;
}

/**
 * Filter routing tables by VPC ID
 * @param fullRouteTablesData - Array of route table objects from API
 * @param selectedVpc - Selected VPC ID
 * @returns Array of filtered route table element IDs
 */
export const getFilteredRoutingTables = (fullRouteTablesData: ApiItem[], selectedVpc: string): string[] => {
  if (!selectedVpc) {
    return fullRouteTablesData.map((item) => item.elementId).filter((id) => id != null && id !== '');
  }
  return fullRouteTablesData
    .filter((item) => item.vpcId === selectedVpc)
    .map((item) => item.elementId)
    .filter((id) => id != null && id !== '');
};

/**
 * Filter network interfaces by VPC ID
 * @param fullNetworkInterfacesData - Array of network interface objects from API
 * @param selectedVpc - Selected VPC ID
 * @returns Array of filtered network interface element IDs
 */
export const getFilteredNetworkInterfaces = (fullNetworkInterfacesData: ApiItem[], selectedVpc: string): string[] => {
  if (!selectedVpc) {
    return fullNetworkInterfacesData.map((item) => item.elementId).filter((id) => id != null && id !== '');
  }
  return fullNetworkInterfacesData
    .filter((item) => item.vpcId === selectedVpc)
    .map((item) => item.elementId)
    .filter((id) => id != null && id !== '');
};

/**
 * Get empty items message for dropdowns based on VPC selection and loading state
 * @param selectedVpc - Selected VPC ID
 * @param isLoading - Loading state
 * @param defaultMessage - Default message when VPC is selected and not loading
 * @returns Appropriate message for dropdown
 */
export const getEmptyItemsMessage = (
  selectedVpc: string, 
  isLoading: boolean, 
  defaultMessage = "No items available"
): string => {
  if (!selectedVpc) {
    return "Please select a VPC first";
  }
  if (isLoading) {
    return "Loading...";
  }
  return defaultMessage;
};
